import { motion } from 'framer-motion';
import { Link, useNavigate } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';
import { Button } from './ui/button';

// Preview images for homepage (only 4)
const previewImages = [
  { src: "https://customer-assets.emergentagent.com/job_family-cleaning-kc/artifacts/yclah6um_5748846733002107081.jpeg", title: "Living Room" },
  { src: "https://customer-assets.emergentagent.com/job_family-cleaning-kc/artifacts/sh4kjh5v_7607940655992651147.jpeg", title: "Kitchen" },
  { src: "https://customer-assets.emergentagent.com/job_family-cleaning-kc/artifacts/valxabkm_7421727686695433658.jpeg", title: "Our Team" },
  { src: "https://customer-assets.emergentagent.com/job_family-cleaning-kc/artifacts/g6sq648e_5622193362639120542.jpeg", title: "Bathroom" },
];

export const PhotoGallery = ({ onBubbleClick }) => {
  const navigate = useNavigate();

  const handleSeeMore = (e) => {
    if (onBubbleClick) {
      onBubbleClick(e);
      setTimeout(() => navigate('/gallery'), 400);
    } else {
      navigate('/gallery');
    }
  };

  return (
    <div>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        {previewImages.map((image, index) => (
          <motion.div
            key={index}
            initial={{ opacity: 0, scale: 0.9 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ delay: index * 0.1 }}
            className="group relative aspect-square rounded-xl overflow-hidden shadow-lg cursor-pointer"
            data-testid={`gallery-preview-${index}`}
          >
            <img
              src={image.src}
              alt={image.title}
              className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-slate-900/70 via-transparent to-transparent 
                            opacity-0 group-hover:opacity-100 transition-opacity duration-300">
              <div className="absolute bottom-0 left-0 right-0 p-3">
                <p className="text-white font-medium text-sm">{image.title}</p>
              </div>
            </div>
          </motion.div>
        ))}
      </div>
      
      {/* See More Button */}
      <motion.div 
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        className="mt-8 text-center"
      >
        <Button
          onClick={handleSeeMore}
          className="rounded-full bg-gradient-to-r from-pink-500 to-pink-600 hover:from-pink-600 hover:to-pink-700 
                     text-white px-8 py-6 text-lg font-medium shadow-lg shadow-pink-500/30"
          data-testid="see-more-gallery-btn"
        >
          See More Photos
          <ChevronRight className="w-5 h-5 ml-2" />
        </Button>
      </motion.div>
    </div>
  );
};

export default PhotoGallery;
